import {Form, InputNumber, Row, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import IBaseProps from "../../../../../../model/interface/IBaseProps";
import IRestServiceFilters from "../../../../../../model/interface/api/IRestServiceFilters";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import FieldPicker from "../../../../../shared/pickers/FieldPicker";
import {SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import PresenterPicker from "../../../../../shared/pickers/PresenterPicker";
import ContentTypePicker from "../../../../../shared/pickers/ContentTypePicker";
import FilterTreeBuilder from "../../../../view/settings/customFilters/FilterTreeBuilder";

export interface IFieldTextSelectOptions{
    textSelectFilters?: IRestServiceFilters
    textSelectFullClassName?: string
    textSelectPresenter?: string
    textSelectAutocompleteField?: string
    textSelectOrderField?: string[] | string
    textSelectOrderDirection?: 'ASC' | "DESC"
    textSelectDropdownMatchSelectWidth?: boolean
    textSelectDropdownHeight?: number
}

interface IProps extends IFieldOptionsEditorProps, IBaseProps {
    originalContentType?: IContentType
}

class FieldTextSelectOptionsEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName, options, match, history, originalContentType} = this.props
        return <div>

            <Form.Item label={<LocaleText code={'configuration.field.text-select.options.content-type'}
                                          fallback={'Typ obsahu'}/>} name={buildFieldName("textSelectFullClassName")}
                       rules={[{required: true}]}>
                <ContentTypePicker output={'className'}/>
            </Form.Item>

            {options.textSelectFullClassName ? (
                <div>
                    <Form.Item label={"Zobrazení"} name={buildFieldName("textSelectPresenter")}
                               rules={[{required: true}]}>
                        <PresenterPicker serviceClassName={options.textSelectFullClassName}/>
                    </Form.Item>
                    <Form.Item name={buildFieldName('textSelectFilters')} label={<LocaleText code={'configuration.field.text-select.options.filter'} fallback={'Filter'}/>}>
                        <FilterTreeBuilder history={history} match={match} originalContentTypeFullClassName={originalContentType?.fullClassName}
                                           contentTypeFullClassName={options.textSelectFullClassName}/>
                    </Form.Item>
                    <Form.Item label={"Řadit směr"} name={buildFieldName("textSelectOrderDirection")}
                               initialValue={'ASC'}>
                        <Select allowClear={true}>
                            <Select.Option key={'asc'} value={"ASC"}>
                                <Row justify={"space-between"} align={"middle"}>
                                    Vzestupně<SortAscendingOutlined style={{fontSize: 20}}/>
                                </Row>
                            </Select.Option>
                            <Select.Option key={'desc'} value={"DESC"}>
                                <Row justify={"space-between"} align={"middle"}>
                                    Sestupně<SortDescendingOutlined style={{fontSize: 20}}/>
                                </Row>
                            </Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name={buildFieldName('textSelectDropdownMatchSelectWidth')} label={<LocaleText
                        code={'configuration.field.text-select.options.dropdown-match-select-width'}
                        fallback={'Rozbalovací nabídka bude odpovídat šířce prvku výběru'}/>} valuePropName={'checked'}
                               initialValue={true}>
                        <Switch/>
                    </Form.Item>
                    <Form.Item name={buildFieldName('textSelectDropdownHeight')}
                               label={<LocaleText code={'configuration.field.text-select.options.dropdown-height'}
                                                  fallback={'Výška rozbalovací nabídky'}/>}>
                        <InputNumber min={20}/>
                    </Form.Item>
                    <Form.Item label={"Řadit dle"} name={buildFieldName("textSelectOrderField")}>
                        <FieldPicker multiple={true} serviceClassName={options.textSelectFullClassName}
                                     output={'name'}/>
                    </Form.Item>
                </div>
            ) : <></>}
        </div>
    }
}


export default FieldTextSelectOptionsEditor